import Cookies from 'js-cookie';

export function getCookie(key) {
  return Cookies.get(key);
}
/**
 * 设置Cookie
 * @param {*} key
 * @param {*} val
 * @param {*} expires 过期时间 单位：天，不足一天用小数
 */
export function setCookie(key, val, expires) {
  if (expires) {
    return Cookies.set(key, val, { expires: expires });
  }
  return Cookies.set(key, val);
}

export function removeCookie(key) {
  return Cookies.remove(key);
}

/**
 * Token 辅助类
 */
class TokenUtil {
  constructor() {
    (this.orgKey = 'apollo_org_' + process.env.API_ENV_TAG),
      (this.tokenKey = 'apollo_student_' + process.env.API_ENV_TAG),
      (this.studentKey = 'apollo_studentInfo_' + process.env.API_ENV_TAG),
      (this.openidKey = 'apollo_openid_' + process.env.API_ENV_TAG),
      // 默认过期时间
      (this.defaultExpires = (1 / 24) * 6);
  }
  get(orgid) {
    return getCookie(this.tokenKey + '_' + orgid);
  }
  set(token, orgid) {
    // env
    token = token + ' ' + process.env.API_ENV_TAG;
    return setCookie(this.tokenKey + '_' + orgid, token, this.defaultExpires);
  }
  remove(orgid) {
    return removeCookie(this.tokenKey + '_' + orgid);
  }
  getorg() {
    return getCookie(this.orgKey);
  }
  setorg(org) {
    return setCookie(this.orgKey, org, 7);
  }
  removeorg() {
    return removeCookie(this.orgKey);
  }
  getStudent(orgid) {
    return getCookie(this.studentKey + '_' + orgid);
  }
  setStudent(student, orgid) {
    return setCookie(this.studentKey + '_' + orgid, student, 7);
  }
  removeStudent(orgid) {
    return removeCookie(this.studentKey + '_' + orgid);
  }
}
export const tokenUtil = new TokenUtil();



// WEBPACK FOOTER //
// ./src/utils/cookie.js